import { random, round2Str } from "../helpers/helpers";

export const generate_outdoor_year_chart_demo = ({ year }) => {
    const currentMonth =
        year === new Date().getFullYear()
            ? new Date().getMonth() + 1
            : 12;

    const monthly_energy_data = [];

    for (let month = 1; month <= currentMonth; month++) {
        monthly_energy_data.push({
            month,
            avg_co: round2Str(random(600, 1400)),
            avg_co_monoxide: 0.0,
            avg_formaldehyde: "13.00",
            avg_humidity: round2Str(random(45, 60)),
            avg_no2: 0.0,
            avg_o3: 0.0,
            avg_pm10: round2Str(random(50, 75)),
            avg_pm2: round2Str(random(48, 72)),
            avg_smoke: round2Str(random(800, 2200)),
            avg_so2: 0.0,
            avg_temp: round2Str(random(25, 29)),
            avg_tvoc: round2Str(random(2000, 8000)),

            max_co: round2Str(random(2500, 4500)),
            max_pm10: round2Str(random(200, 350)),
            max_pm2: round2Str(random(190, 340)),
            max_smoke: round2Str(random(6000, 13000)),
            max_temp: round2Str(random(29, 32)),
            max_tvoc: "30000.00",

            min_co: "403.00",
            min_pm10: round2Str(random(10, 40)),
            min_pm2: round2Str(random(10, 38)),
            min_smoke: round2Str(random(20, 300)),
            min_temp: round2Str(random(23, 25)),
            min_tvoc: round2Str(random(900, 1200)),
        });
    }

    return {
        monthly_energy_data,
        is_co: true,
        is_co_monoxide: true,
        is_formaldehyde: true,
        is_humidity: true,
        is_no2: true,
        is_o3: true,
        is_pm10: true,
        is_pm2: true,
        is_smoke: true,
        is_so2: true,
        is_temperature: true,
        is_tvoc: true,
        year,
    };
};